import { Injectable } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { ActivityModelNew } from "../models/newChanges";

@Injectable()
export class ActivityDependencyService {
  dependency = {};

  constructor() {}

  public hasAllowToAnswer(activityId): boolean {
    let hasAllowToAnsFlag = true;
    const depActivityList = this.dependency[activityId].dependedActivityList;
    if (depActivityList.length > 0) {
      depActivityList.forEach((actObj) => {
        if (this.dependency[actObj].hasAnswer) {
          hasAllowToAnsFlag = false;
        }
      });
    }

    this.dependency[activityId].hasAllowToAnswer = hasAllowToAnsFlag;

    return hasAllowToAnsFlag;
  }

  public addDeleteStatus(questionList): void {
    questionList.forEach((question) => {
      question.status = "delete";
    });
  }

  public checkHasAllowToAnswer(
    activity: ActivityModelNew,
    toggleCtl: UntypedFormControl
  ): void {
    let hasAllowToAnsFlag = true;
    const depActivityList = this.dependency[activity.id].dependedActivityList;
    if (depActivityList.length > 0) {
      depActivityList.forEach((actObj) => {
        if (this.dependency && this.dependency[actObj].hasAnswer) {
          hasAllowToAnsFlag = false;
        }
      });
    }
    if (this.dependency[activity.id]) {
      this.dependency[activity.id].hasAllowToAnswer = hasAllowToAnsFlag;
      if (!hasAllowToAnsFlag && activity.toggleFlag) {
        toggleCtl.setValue(false);
        this.dependency[activity.id].hasAnswer = false;
        activity.toggleFlag = !activity.toggleFlag;
        activity.status = "delete";
        this.addDeleteStatus(activity.questionList);
      }
    }
  }
}
